<template>
  <router-link
    v-if="currentAdId"
    :to="{ name: 'mediaDetail', params: { id: currentAdId } }"
  >
    <div class="relative mb-3 w-full h-96 overflow-hidden rounded-md bg-black">
  <img
  v-if="currentAdThumb"
  :src="currentAdThumb"
  class="absolute inset-0 m-auto w-[100%] h-[100%] object-fill z-0"
  alt=""
  loading="lazy"
  decoding="async"
/>

<div class="absolute inset-0 bg-[rgba(0,0,0,0.74)] z-10"></div>

<IconPlay class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20" />
</div>
  </router-link>
</template>

<script>
import IconPlay from '@icons/IconPlay.vue'

export default {
  name: 'VideoBanner',
  components: { IconPlay },

  props: {
    content: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      adInterval: null,
      adImageIndex: 0,
      currentAd: null,
    }
  },

  computed: {
    // ✅ важно: id берём так, чтобы работало и с разными форматами
    currentAdId() {
      // если бек/нормализация отдаёт {id: 33}
      if (this.currentAd?.id) return this.currentAd.id

      // если вдруг отдаст {video:{id:33}}
      if (this.currentAd?.video?.id) return this.currentAd.video.id
          
      return null
    },

    currentAdThumb() {
      return this.currentAd?.thumbnail ?? this.currentAd?.video?.thumbnail ?? null
    },
  },

  methods: {
    startRotation() {
      this.stopRotation()

      if (!this.content || !this.content.length) {
        this.currentAd = null
        return
      }

      this.adImageIndex = 0
      this.currentAd = this.content[0]

      if (this.content.length > 1) {
        const time = 5000
        this.adInterval = setInterval(this.changeImage, time)
      }
    },

    stopRotation() {
      if (this.adInterval) {
        clearInterval(this.adInterval)
        this.adInterval = null
      }
    },

    changeImage() {
      if (!this.content || !this.content.length) return
      this.adImageIndex = (this.adImageIndex + 1) % this.content.length
      this.currentAd = this.content[this.adImageIndex]
    },
  },

  watch: {
    content: {
      immediate: true,
      handler() {
        this.startRotation()
      },
    },
  },

  unmounted() {
    this.stopRotation()
  },
}
</script>